<template>
<div>
  <MyBankItems :formTitle="formTitle" v-if="this.route === 'banks'" />
  <MyBoxItems :formTitle="formTitle" v-if="this.route === 'boxes'" />
  <MyBankAccountItems :formTitle="formTitle" v-if="this.route === 'bank_accounts'" />
  <MyPersonItems :formTitle="formTitle" v-if="this.route === 'persons'" />
  <MyProductItems :formTitle="formTitle" v-if="this.route === 'products'" />
  <MyInvoiceItems :formTitle="formTitle" v-if="this.route === 'invoices'" />
  <MyRPItems :formTitle="formTitle" v-if="this.route === 'receipts'" />
  <MyRPItems :formTitle="formTitle" v-if="this.route === 'payments'" />
  <MyLendingItems :formTitle="formTitle" v-if="this.route === 'lendings'" />
  <!-- <MyDocItems :formTitle="formTitle" v-if="this.route === 'lendings'" /> -->
  <MyCostItems :formTitle="formTitle" v-if="this.route === 'costs'" />
  <MyIncomeItems :formTitle="formTitle" v-if="this.route === 'incomes'" />
  <MyTransferItems :formTitle="formTitle" v-if="this.route === 'transfers'" />
  <MyRoleItems :formTitle="formTitle" v-if="this.route === 'roles'" />
  <MyUserItems :formTitle="formTitle" v-if="this.route === 'users'" />
  <MyFiscalYearItems :formTitle="formTitle" v-if="this.route === 'fiscal_years'" />
</div>
</template>

<script>
import MyBankItems from '../../pages/bank/items.vue'
import MyBoxItems from '../../pages/box/items.vue'
import MyBankAccountItems from '../../pages/bank_account/items.vue'
import MyPersonItems from '../../pages/person/items.vue'
import MyProductItems from '../../pages/product/items.vue'
import MyInvoiceItems from '../../pages/invoice/items.vue'
import MyRPItems from '../../pages/rp/items.vue'
import MyLendingItems from '../../pages/lending/items.vue'
// import MyDocItems from '../../pages/doc/items.vue'
import MyCostItems from '../../pages/cost/items.vue'
import MyIncomeItems from '../../pages/income/items.vue'
import MyTransferItems from '../../pages/transfer/items.vue'
import MyUserItems from '../../pages/user/items.vue'
import MyRoleItems from '../../pages/role/items.vue'
import MyFiscalYearItems from '../../pages/fiscal_year/items.vue'
//
export default {
  name: "data-add",
  async beforeCreate() {
    this.route = this.$store.getters.pageInfo.route
    this.formState = this.$router.currentRoute.path.split("/")[2]
    // console.log(this.formState);
    if (this.formState === 'add') {
      this.formTitle = `افزودن ${this.$store.getters.pageInfo.formTitle} جدید ...`
    } else if (this.formState === 'edit') {
      this.formTitle = `ویرایش ${this.$store.getters.pageInfo.formTitle} ...`
    } else if (this.formState === 'password') {
      this.formTitle = `ویرایش کلمه عبور ...`
    }
  },
  components: {
    MyBankItems,
    MyBoxItems,
    MyBankAccountItems,
    MyPersonItems,
    MyProductItems,
    MyInvoiceItems,
    MyRPItems,
    MyLendingItems,
    // MyDocItems,
    MyCostItems,
    MyIncomeItems,
    MyTransferItems,
    MyUserItems,
    MyRoleItems,
    MyFiscalYearItems,
  }
}
</script>
